module.exports = __webpack_public_path__ + "static/media/blog.ca3d5eb0.svg";